import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Box
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Aish5XLogo } from "../branding/Aish5XLogo";

const Header = () => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (state: boolean) => () => {
    setOpen(state);
  };

  const menuItems = [
    { text: "個人設定", link: "/settings" },
    { text: "ログアウト", link: "/logout" },
    { text: "ヘルプ", link: "/help" },
  ];

  return (
    <header className="fixed top-0 left-0 w-full z-[999] h-14 bg-white shadow flex items-center justify-between px-4">
      {/* 左側 ロゴ */}
      <Link to="/">
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            px: 2,
          }}
        >
          <Aish5XLogo height={32} />
        </Box>
      </Link>

      {/* 右側 メニュー */}
      <div className="flex items-center gap-4">
        {/* 新規登録 */}
        <Link to="/signup" className="text-sm hover:underline">
          新規登録
        </Link>

        {/* ログイン */}
        <Link to="/login" className="text-sm hover:underline">
          ログイン
        </Link>

        {/* バーガーメニュー */}
        <IconButton onClick={toggleDrawer(true)}>
          <MenuIcon fontSize="large" />
        </IconButton>
      </div>

      {/* Drawer */}
      <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
        <List sx={{ width: 200 }}>
          {menuItems.map((item) => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton component={Link} to={item.link} onClick={toggleDrawer(false)}>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </header>
  );
};

export default Header;
